var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("PAGE_CLIENTUSER_EMAIL"),
        visible: "",
        width: "70%",
      },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { height: "300px", data: _vm.data, border: "", stripe: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "50" } }),
          _c("el-table-column", {
            attrs: {
              prop: "userAccount",
              label: _vm.$t("COMMON_USER_ACCOUNT"),
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "title", label: _vm.$t("TABLE_HEADER_title2") },
          }),
          _c("el-table-column", {
            attrs: { prop: "userName", label: _vm.$t("COMMON_USER_NAME") },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "roleList",
              width: "140",
              label: _vm.$t("TABLE_HEADER_Roles"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "wl-overflow-tooltip",
                        attrs: { title: _vm.roleListName(scope.row.roleList) },
                      },
                      [_vm._v(_vm._s(_vm.roleListName(scope.row.roleList)))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "emailStatus",
              label: _vm.$t("TABLE_HEADER_EMAIL_STATUS"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.emailStatus ? "sent" : "unsent") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticClass: "wl-pagination",
        attrs: {
          "current-page": _vm.pagination.pageNum,
          "page-size": _vm.pagination.pageSize,
          layout: "prev, pager, next,total",
          total: _vm.pagination.total,
        },
        on: { "current-change": _vm.onCurrentPageChange },
      }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "wl-grey", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary", loading: _vm.saveLoading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("comment_send")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }